import { render, staticRenderFns } from "./body-phone.vue?vue&type=template&id=74882cb0&scoped=true&"
var script = {}
import style0 from "./body-phone.vue?vue&type=style&index=0&id=74882cb0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74882cb0",
  null
  
)

export default component.exports